<div class="autocomplete-wrapper">
    <form [formGroup]="form">
        <mat-form-field>
            <mat-label>Buscar Modulo</mat-label>
            <input type="text" matInput formControlName="search" [matAutocomplete]="auto" />
        </mat-form-field>
        <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onOptionSelected($event)" [displayWith]="displayFn">
            <mat-option *ngFor="let option of filteredModules | async" [value]="option" [class]="getPanelClass(option)"
                [disabled]="!option.Estado">
                {{ option.Nombre }}
            </mat-option>
        </mat-autocomplete>
    </form>
</div>